module.exports = __webpack_public_path__ + "static/media/icon_schedule_disable.0c2864a1.svg";